export default __webpack_public_path__ + "static/area-example-7f882a9f4132be1c03eb1c569fee0a48.webp";